import { B2B_ADDRESSES_PATH, B2B_UPDATE_ADDRESES_PATH, B2B_ACCOUNT_PATH, } from '../../constants/links';
import { apiB2B } from '../axios-client';
export var b2bAddressesApi = {
    addNewAddress: function (address) {
        return apiB2B.post(B2B_UPDATE_ADDRESES_PATH, {
            addressRequest: {
                address: [address],
            },
        });
    },
    deleteAddress: function (_a) {
        var addrIdentifier = _a.addrIdentifier, ownerUserId = _a.userId;
        return apiB2B.delete("".concat(B2B_ADDRESSES_PATH, "/").concat(addrIdentifier), {
            params: {
                ownerUserId: ownerUserId,
            },
        });
    },
    editAddress: function () {
        var addresses = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            addresses[_i] = arguments[_i];
        }
        return apiB2B.put(B2B_UPDATE_ADDRESES_PATH, {
            addressRequest: {
                address: addresses,
            },
        });
    },
    ogHmac: function (_a) {
        var customerSVOCId = _a.customerSVOCId, _b = _a.host, host = _b === void 0 ? '' : _b;
        if (!customerSVOCId) {
            return Promise.reject(new Error('Cannot call ogHmac without custId'));
        }
        var ogHmacUrl = new URL("".concat(B2B_ACCOUNT_PATH, "/").concat(customerSVOCId, "/ogHmac"), host);
        return apiB2B.get(ogHmacUrl.href, {
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
        });
    },
};
